// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OT-CH","right":"styles_right__xKEzT"};